import { SearchService } from '@/service/searchService'
import Model from './Model'

interface ISearchUser {
  contactId: string
  slug: string
  avatar: string
  title: string
  bio: string
  gamificationMeta: Map<string, any>
  lastLogin: string
  isChatDisabled: boolean
  socials: Map<string, string>
}

export interface ISearchHighLighText {
  value: string
  type: 'hit' | 'text'
}
export interface ISearchHighlight {
  score: number
  path: string
  texts: ISearchHighLighText[]
}
export interface ISearch {
  _id: string
  createdAt: Date
  updatedAt: Date
  type: 'SEARCH_POST_MODEL'
  attachments: []
  fullName: string
  author: ISearchUser
  channelId: string
  channelName: string
  channelSlug: string
  commentsCount: number
  content: string
  groupId: string
  locationId: string
  mentions: Array<{ contactId: string }>
  reactions: Map<string, number>
  score: number
  highlightText: ISearchHighlight[]
  thumbnailUrl: string
  title: string
  visibility: string
  token: string
  total: number
  current_user_reactions: {
    reactionType: string
    _id: string
  }
  channelMentions: Array<{ channelId: string }>
  eventMentions: Array<{ eventId: string }>
  [key: string]: any
}
export default class Search extends Model {
  constructor(payload: ISearch) {
    super(payload, SearchService)
  }
  get locationId(): string {
    return this._data.locationId
  }

  set locationId(locationId: string) {
    this._data.locationId = locationId
  }

  get groupId(): string {
    return this._data.groupId
  }

  set groupId(groupId: string) {
    this._data.groupId = groupId
  }
}
